import CryptoJS from 'crypto-js';

export default {
	firstkey:CryptoJS.enc.Utf8.parse("dacheng-20JIAOYU"),
	//加密
	encrypt(word) {
		const srcs = CryptoJS.enc.Utf8.parse(word);
		const encrypted = CryptoJS.AES.encrypt(srcs, this.key, {iv:this.key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
		return encrypted.ciphertext.toString();
	},
	//解密
	decrypt(word) {
		const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
		const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
		const decrypt = CryptoJS.AES.decrypt(srcs, this.key, {iv: this.key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
		return decrypt.toString(CryptoJS.enc.Utf8);
	},
	//设置密钥
	setkey(str){
		const encryptedHexStr = CryptoJS.enc.Hex.parse(str);
		const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
		const decrypt = CryptoJS.AES.decrypt(srcs, this.firstkey, {iv: this.firstkey, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
		const key=decrypt.toString(CryptoJS.enc.Utf8);
		this.key=CryptoJS.enc.Utf8.parse(key);
	}
}